import {VacationAndBreak} from '../vacationAndBreak';

export class VacationVO {
  start1: string | null;
  end1: string | null;
  start2: string | null;
  end2: string | null;
  startPausse: string | null;
  endPausse: string | null;
}
export class PauseVO {
  startPausse: string | null;
  endPausse: string | null;
}
export interface VacationBasicVO {
  debut: string;
  fin: string;
}

export class RequestBodyVacations {
  matricule: string;
  fullName: string;
  forceSiFormation: boolean;
  vacationAndPausesVo: VacationAndBreak;
  timezone: number;
  date: string
  injectionAction: string
  pause: number;
  motif: string;
  etat: any;
  other: any;
  failedReasons?: Array<string>
}

export interface ResponseBodyVacations {
  notInjected: number;
  size: number;
  outSidePaidPeriod: RequestBodyVacations[];
  success: boolean;
  injected: number;
  notValid: number;
  isDirSite: boolean;
  notValidItems: RequestBodyVacations[];
  notInjectedItems: RequestBodyVacations[];
  notAllowedMatricules: Array<string>
}

export interface ResponseHistoryVacations extends RequestBodyVacations{
  id: number;
  addedBy: string;
  addedForEmp: string;
  dateFiche: string;
  status: string;
  etat: any;
  typeAction: string;
  vo: string;
}

export interface HistroyResponse {
  content: ResponseHistoryVacations[];
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  size: number;
  totalElements: number;
  totalPages: number;
}


export interface ValidationVacation {
  decision: string;
  motifReject: string;
  injectionParamVos: Array<{id: number; date: string; etat: any}>
}


export interface DrawerDetails<T> {
  event: "OPEN" | "CLOSE" | "POST_MESSAGE" | "ERROR_REQUEST" | "END";
  data: T
}


export interface HeaderTempateVO {

}



// WEBPACK FOOTER //
// ./src/app/modules/injection/InjectionVO.ts